import React, { useEffect, useState } from "react"
import Page from "../../common/page/Page"
import axios from "axios"
import ButtonArea from "../../common/ButtonArea/ButtonArea"
import Form from "../../common/form/Form"
import ResponsiveTable from "../../common/ResponsiveTable/ResponsiveTable"
import EditIcon from "../../icons/EditIocn"
import DoubleArrowIcon from "../../icons/DoubleArrowIcon"
import Loader from "../../common/loader/Loader"
import { useFlashMessage } from "../../common/hook/useFlashMessage"
import FlashMessage from "../../common/FlashMesage/FlashMessage"
import { useAuth } from "../../data/useAuth"

const CategoryPage = () => {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [formActive, setFormActive] = useState(false)
  const [isAdd, setIsAdd] = useState(true)
  const [currentCategoryId, setCurrentCategoryId] = useState(null)
  const { flash, showMessage, hideMessage } = useFlashMessage()
  const { signOut } = useAuth()
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    gst: 0,
  })

  useEffect(() => {
    fetchCategories()
  }, [])

  const fetchCategories = async () => {
    try {
      const response = await axios.get("/api/categories")
      setCategories(response.data || [])
    } catch (err) {
      signOut()
      setError(err.response?.data?.message || err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target
    setFormData((prev) => ({ ...prev, [id]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!formData.name.trim()) return alert("Name required.")
    if (!formData.description.trim()) return alert("Description required.")
    if (formData.gst === "" || isNaN(formData.gst))
      return alert("GST should be a valid number.")

    try {
      setLoading(true)
      setFormActive(false)
      if (isAdd) {
        const response = await axios.post("/api/categories", formData)
        setCategories((prev) => [...prev, response.data])
        showMessage({ message: "Category added.", type: "success" })
      } else {
        const response = await axios.put(
          `/api/categories/${currentCategoryId}`,
          formData
        )
        setCategories((prev) =>
          prev.map((cat) =>
            cat.id === currentCategoryId ? response.data : cat
          )
        )
        showMessage({ message: "Category updated.", type: "success" })
      }

      setFormData({ name: "", description: "", gst: 0 })
      setCurrentCategoryId(null)
      setIsAdd(true)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setFormActive(false)
      setError(err.response?.data?.error || err.message)
    }
  }

  const handleEdit = (category) => {
    setIsAdd(false)
    setFormActive(true)
    setCurrentCategoryId(category.id)
    setFormData({
      name: category.name,
      description: category.description,
      gst: category.gst,
    })
  }

  return (
    <Page title={"Category"} is_admin={true}>
      {!formActive && (
        <ButtonArea>
          <button
            onClick={() => {
              setFormActive(true)
              setIsAdd(true)
              setFormData({ name: "", description: "", gst: 0 })
              setCurrentCategoryId(null)
            }}
          >
            Add Category
          </button>
        </ButtonArea>
      )}

      {formActive && (
        <Form is_admin={true} onSubmit={handleSubmit}>
          <div>
            <div>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Category Name"
                required
              />
            </div>
          </div>

          <div>
            <div>
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Category Description"
                required
              />
            </div>
          </div>

          <div>
            <div>
              <label htmlFor="gst">GST in %</label>
              <input
                type="number"
                id="gst"
                value={formData.gst}
                onChange={handleInputChange}
                placeholder="GST in %"
                required
              />
            </div>
          </div>

          <ButtonArea>
            <button type="submit">{isAdd ? "Add" : "Update"} Category</button>
            <button
              type="button"
              onClick={() => {
                setFormActive(false)
                setFormData({ name: "", description: "", gst: 0 })
                setIsAdd(true)
                setCurrentCategoryId(null)
              }}
            >
              Close
            </button>
          </ButtonArea>
        </Form>
      )}

      {loading && (
        <div style={{ height: "calc(100svh - 100px)", display: "flex" }}>
          <div style={{ margin: "auto" }}>
            <Loader />
          </div>
        </div>
      )}

      {!loading && !error && !formActive && (
        <ResponsiveTable>
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>GST %</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((cat) => (
              <tr key={cat.id}>
                <td data-label="Id">{cat.id}</td>
                <td data-label="Name">{cat.name}</td>
                <td data-label="GST %">{cat.gst}</td>
                <td data-label="Actions">
                  <EditIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => handleEdit(cat)}
                  />
                  <DoubleArrowIcon />
                </td>
              </tr>
            ))}
          </tbody>
        </ResponsiveTable>
      )}

      {flash && (
        <FlashMessage
          message={flash.message}
          type={flash.type}
          onClose={hideMessage}
        />
      )}
    </Page>
  )
}

export default CategoryPage
